/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useState, useContext, useCallback, useEffect, useMemo } from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, FormHelperText, Grid, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import { IoArrowBackSharp, IoClose } from 'react-icons/io5';
import SelectDuration from './Duration';
import { LanguageContext } from '../../../../../../libs/Context';
import { MdClear } from 'react-icons/md';
import { RiCheckboxCircleLine } from 'react-icons/ri';

const AddPoll = (props) =>
{
	const { handlepollClose, pollOpen, handlePollData, from, editPoll } = props;
	const { language } = useContext(LanguageContext);
	const [ optionErrors, setOptionErrors ] = useState<boolean[]>([ false ]);
	const [ pollData, setPollData ] = useState({
		question     : '',
		questionType : 'single',
		options      : [ '' ],
		duration     : 1
	});

	useEffect(() =>
	{
		if (from === 'edit')
		{
			const durationObj = {
				1  : 1,
				2  : 2,
				7  : 3,
				14 : 4
			};

			const obj = {
				question     : editPoll?.question,
				questionType : editPoll?.questionType,
				options      : editPoll?.options?.map((item) => item?.option),
				duration     : durationObj[editPoll?.inlynkDurationInDays]
			};

			setPollData((prev) => ({ ...prev, ...obj }));
		}
	}, [ editPoll ]);

	const handleQuestionChange = (event) =>
	{
		// let newQuestions = JSON.parse(JSON.stringify(pollData));
		let newQuestions = { ...pollData, options: [ ...pollData?.options ] };

		if (pollData?.question !== event?.target?.value?.replace(/\s+/g, ' '))
		{
			newQuestions = { ...newQuestions, question: event?.target?.value?.replace(/\s+/g, ' ') };
			setPollData((prev:any) => ({ ...prev, ...newQuestions }));
		}
	};

	const hideAdd = useMemo(() => pollData?.options.length >= 4, [ pollData.options ]);
	const disableAdd = useMemo(() => pollData.options.some((item) => !item), [ pollData.options ]);
	const handleAddOption = () =>
	{
		setPollData({ ...pollData, options: [ ...pollData.options, '' ] });
		setOptionErrors([ ...optionErrors, false ]);
	};

	const handleDeleteOption = (index) =>
	{
		const newOptions = pollData.options.filter((_, i) => i !== index);

		setPollData({ ...pollData, options: newOptions });

		const newErrors = optionErrors.filter((_, i) => i !== index);

		setOptionErrors(newErrors);
	};

	const handleOptionChange = (optionIndex, event) =>
	{
		const updatedValue = event.target.value.replace(/^\s+/, '');

		const newOptions = [ ...pollData.options ];

		newOptions[optionIndex] = updatedValue;
		setPollData({ ...pollData, options: newOptions });

		const newErrors = Array.from({ length: pollData.options.length }).fill(false) as boolean[];

		// newErrors[optionIndex] = updatedValue.trim() === '';
		setOptionErrors(newErrors);
	};

	const inLynkDurationValues = {
		1 : 1,
		2 : 2,
		3 : 7,
		4 : 14
	};
	const linkdinDurationValues = {
		1 : 'ONE_DAY',
		2 : 'TWO_DAYS',
		3 : 'SEVEN_DAYS',
		4 : 'FOURTEEN_DAYS'
	};
	const xDurationValues = {
		1 : 1440,
		2 : 2880,
		3 : 10080,
		4 : 20160
	};

	const handleNext = async () =>
	{
		const newError = pollData.options.map((each, ind1) => pollData.options.some((each2, ind2) => each.toLowerCase() === each2.toLowerCase() && ind1 !== ind2));

		if (newError.some((each) => each))
		{
			setOptionErrors(newError);

			return;
		}
		const pollObj = {
			question             : pollData?.question,
			questionTyp          : pollData?.questionType,
			options              : pollData?.options?.filter((each) => each?.trim() !== '')?.map((each) => ({ option: each })),
			inlynkDurationInDays : inLynkDurationValues[pollData?.duration],
			linkedInDuration     : linkdinDurationValues[pollData?.duration],
			xDurationInMin       : xDurationValues[pollData?.duration]
		};

		handlePollData(pollObj);

		handlepollClose();
	};

	const handleDuration = useCallback((durationId) =>
	{
		setPollData((prev) => ({ ...prev, duration: durationId }));
	}, [ pollData ]);

	const hasErrors = optionErrors.some((option) => option);
	const disableNext = pollData?.question === '' || disableAdd || pollData?.duration === 0 || hasErrors;

	return (
		<Dialog open={pollOpen} fullWidth maxWidth='sm' onClose={handlepollClose}>
			<DialogTitle>
				<Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
					<Stack direction={'row'} alignItems={'center'} spacing={1}>
						<IoArrowBackSharp style={{ cursor: 'pointer' }} onClick={handlepollClose} />
						<Typography variant='body1' fontWeight='var(--font500)'>{language?.addPolls}</Typography>
					</Stack>
					<IoClose style={{ cursor: 'pointer' }} onClick={handlepollClose} />
				</Stack>
			</DialogTitle>
			<DialogContent>
				<Grid container>
					<Grid item direction={'column'} spacing={1} sx={{ width: 'var(--percent100)' }}>
						<Typography variant='body1' sx={{ p: 1 }}>{language?.question}</Typography>
						<TextField
							sx={{ p: 1 }}
							id='outlined-basic'
							autoFocus={!pollData?.question}
							hiddenLabel
							fullWidth
							size='small'
							variant='outlined'
							placeholder={language.enterUrQuestion}
							value={pollData?.question}
							onChange={handleQuestionChange}
							inputProps={{ maxLength: 140 }}
						/>

						<Typography sx={{ p: 1 }} variant='body1'>{language?.options}</Typography>
						{pollData?.options.map((option, index) => (
							// <span key={index}>
							<TextField
								key={index}
								sx={{ p: 1 }}
								id={`option-${index}`}
								error={optionErrors[index]}
								hiddenLabel
								fullWidth
								size='small'
								variant='outlined'
								value={option}
								inputProps={{ maxLength: 25 }}
								autoFocus={Boolean(pollData?.question) && !option}
								placeholder={language.enterTheOption}
								onChange={(e) => handleOptionChange(index, e)}
								InputProps={{
									endAdornment : pollData.options.length > 1 && (
										<InputAdornment position='end' onClick={() => handleDeleteOption(index)}>
											<MdClear cursor={'pointer'} fontSize='var(--pixel20)' />
										</InputAdornment>
									)
								}}
							/>
							// </span>
						))}
						{hasErrors && (
							<FormHelperText
								id='txtFirstName-error'
								className='errorTxt'
								sx={{ paddingLeft: '8px' }}
							>
								{language?.duplicateOption}
							</FormHelperText>
						)}
						{!hideAdd &&
						<Box display='flex' justifyContent='flex-end' sx={{ p: 1 }}>
							<Button variant='outlined'
								onClick={handleAddOption}
								disabled={disableAdd}
							>
								{language?.add}+
							</Button>
						</Box>}
					</Grid>
					<SelectDuration handleDuration={handleDuration} duration={pollData?.duration}/>
				</Grid>
			</DialogContent>
			<Box
				sx={{
					display        : 'flex',
					justifyContent : 'flex-end',
					p              : 2,
					mr             : 2
				}}
			>
				<Button variant='contained' color='primary'
					onClick={handleNext}
					className={disableNext ? 'disableMode buttonBg' : 'buttonBg'}
					sx={{
						backgroundColor : 'var(--primaryColor)',
						color           : 'var(--whiteColor)',
						cursor          : 'pointer'
					}}
					disabled={disableNext}
				>
					{language?.next}
				</Button>
			</Box>
		</Dialog>
	);
};

export default AddPoll;
